export const toTitleCaseArray = function(theArray) {
    if(!theArray){
        return [];
    }
    for (let i = 0; i < theArray.length; i++) {
        theArray[i] = theArray[i].replace(
            /\w\S*/g,
            function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    }
    return theArray;
};

export const getTimeForDay = function(times, opensOrCloses) {
    if(opensOrCloses === 'opens'){
        if(times.openHour && times.openMinutes){
            return times.openHour + ':' + times.openMinutes;
        }
    }else if(opensOrCloses === 'closes'){
        if(times.closeHour && times.closeMinutes){
            return times.closeHour + ':' + times.closeMinutes;
        }
    }
    return null;
};

export const formatDigits = function(digits) {
    return digits.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
};